export default __webpack_public_path__ + "static/media/logo-goose.f54dc89a.png";